import { Component, Input, EventEmitter, Output, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormArray, FormControl, FormGroup, AbstractControl } from '@angular/forms';

import { forkJoin } from 'rxjs';

import { ConfigurationService } from '@commons/services/configuration/configuration.service';
import { VehicleService } from '@commons/services/vehicle/vehicle.service';
import { Config } from '../../../../commons/models/domain/Config';

@Component({
    selector: 'tk-vehicle-list-config',
    templateUrl: './vehicle-list-full-config.component.html',
    styleUrls: ['./vehicle-list-full-config.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class VehicleListFullConfigComponent implements OnInit {

    @Output()
    onClose: EventEmitter<any> = new EventEmitter();

    /**
     * formularz
     */
    public form: FormArray;


    /**
     * zaznaczanie
     */
    public selectAllControl: AbstractControl;

    /**
     * rodzaje czujnikow
     */
    public indicatorTypeGroups: any[] = [];

    /**
     * model
     */
    public config?: Config;

    constructor(
        private $vehicleService: VehicleService,
        private $configService: ConfigurationService,
        private $fb: FormBuilder
    ) {

        // budowanie formularza
        this.form = this.$fb.array([]);
        this.form.valueChanges.subscribe(changes => {
            const data = this.form.getRawValue();
            this.config!.VehicleFullListColumns = data.filter(r => r.Selected === true).map(r => r.Type);
            this.config!.VehicleFullListColumnsOrder = data.sort((a, b) => {
                if (a.Level > b.Level) {
                    return 1;
                } else if (a.Level < b.Level) {
                    return -1;
                } else {
                    if (a.Name > b.Name) {
                        return 1;
                    } else if (a.Name < b.Name) {
                        return -1;
                    } else {
                        return 0;
                    }
                }

            }).map(f => f.Type);
        });

        // budowanie kontrolki zaznaczania
        this.selectAllControl = this.$fb.control(null);
        this.selectAllControl.valueChanges.subscribe(flag => {


            for (let i = this.form.controls.length - 1; i >= 0; i--) {
                const control = <FormGroup>this.form.at(i);
                control.controls['Selected'].setValue(flag);
            }
        });
    }

    ngOnInit() {

        // streamy
        const s1 = this.$configService.getConfig();
        const s2 = this.$vehicleService.getVehicleControlIndicatorTypeList$();

        forkJoin([
            s1, s2
        ]).subscribe(results => {

            // wybik pierwszego streamu
            this.config = <Config>results[0];

            const sortOrder = this.config.VehicleFullListColumnsOrder || [13, 2, 11, 12, 1, 4, 19, 14, 15, 8, 7, 17, 3, 16];

            // wybik drugiego streamu
            const result = results[1];
            const indicatorTypes = result.sort((a, b) => {
                const ai = sortOrder.indexOf(a.Type);
                const bi = sortOrder.indexOf(b.Type);

                if (ai > bi) {
                    return 1;
                } else if (ai < bi) {
                    return -1;
                } else {
                    if (a.Name > b.Name) {
                        return 1;
                    } else if (a.Name < b.Name) {
                        return -1;
                    } else {
                        return 0;
                    }
                }

            });


            // utworzenie formularz
            const VehicleFullListColumns = this.config.VehicleFullListColumns.concat([]);
            for (let i = 0; i < indicatorTypes.length; i++) {

                // czujnik
                const indicatorType = indicatorTypes[i];

                const Type = this.$fb.control(0);
                const Name = this.$fb.control('');
                const Selected = this.$fb.control(false);
                const First = this.$fb.control(i === 0);
                const Last = this.$fb.control(i === indicatorTypes.length - 1);
                const Level = this.$fb.control(i);

                // aktualizacja
                const SelectedValue = VehicleFullListColumns.indexOf(indicatorType.Type) !== -1;
                Selected.setValue(SelectedValue);

                const Item = this.$fb.group({
                    Type: Type,
                    Name: Name,
                    Selected: Selected,
                    First: First,
                    Last: Last,
                    Level: Level
                });

                this.form.push(Item);


                // aktualizacja
                Item.patchValue( { Name: indicatorType.Name, Type: indicatorType.Type });

            }


            this.groupBy();



        });
    }


    // grupowanie
    groupBy() {
        const groupCount = 7;
        // grupowanie
        this.indicatorTypeGroups = [];
        let indicatorTypeGroup: number[] = [];
        for (let i = 0; i < this.form.length; i++) {
            // przygotowanie grup
            if (i % groupCount === 0) {
                indicatorTypeGroup = [];
                this.indicatorTypeGroups.push(indicatorTypeGroup);
            }
            indicatorTypeGroup.push(i);
        }
    }

    /**
     * zamkniecie okna
     */
    close() {
        // zapisanie konfiguracji
        const s1 = this.$configService.saveConfig(this.config!).subscribe();

        // zamkniecie
        this.onClose.emit(null);
    }


    moveUp(el: AbstractControl) {
        const level: number = el.get('Level')!.value;
        for (let i = 0; i < this.form.length; i++) {
            if (i === level - 1) {
                const item = <FormGroup>this.form.at(i);
                item.controls['Level'].setValue(level);
                el.get('Level')!.setValue(level - 1);

                this.form.removeAt(i);
                this.form.insert(i + 1, item);
            }
        }
        for (let i = 0; i < this.form.length; i++) {
            const item = <FormGroup>this.form.at(i);
            item.controls['First'].setValue(i === 0);
            item.controls['Last'].setValue(i === this.form.length - 1);
        }

        this.groupBy();
    }

    moveDown(el: AbstractControl) {
        const level: number = el.get('Level')!.value;
        for (let i = 0; i < this.form.length; i++) {
            if (i === level + 1) {
                const item = <FormGroup>this.form.at(i);
                item.controls['Level'].setValue(level);
                el.get('Level')!.setValue(level + 1);

                this.form.removeAt(i);
                this.form.insert(i - 1, item);

            }
        }
        for (let i = 0; i < this.form.length; i++) {
            const item = <FormGroup>this.form.at(i);
            item.controls['First'].setValue(i === 0);
            item.controls['Last'].setValue(i === this.form.length - 1);
        }
        this.groupBy();
    }

}
